// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/2fb0eda2/" + chunkId + "." + __webpack_require__.h() + ".v2fb0eda2.js";
};